import { ITypedReduxAction } from '../../../types/redux/actionType';

export enum EResetQuestionListActionType {
  Reset = 'questionList/resetQuestionList',
}

export type TResetQuestionList = ITypedReduxAction<EResetQuestionListActionType.Reset>;
